module.exports = "dist/videos/help/image-box-title-spacing.mp4";